export enum ChartSettingsShowOptions {
  Area = 'area',
  Bar = 'bar',
  Cumulative = 'cumulative',
  Line = 'line',
  HorizontalBar = 'horizontal-bar',
  PieChart = 'pie',
  VerticalBar = 'vertical-bar',
}
